import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0 15px;

  h1 {
    text-align: center;
    color: var(--text-color-2);
    font-size: 2.4rem;
    font-weight: 600;
  }

  p {
    max-width: 560px;
    margin-top: 15px;

    text-align: center;
    color: var(--text-color-3);
    font-size: 1.1rem;
    line-height: 1.5;
    overflow: visible;
    white-space: normal;
  }

  a {
    margin-top: 25px;

    color: var(--main-color);
    font-weight: 600;
    font-size: 15px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
